module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-magenta.95007cad.svg";